import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Centred spinner used for full-page loading states (login, logout,
 * impersonation handoffs). Keep the markup intentionally small — this is
 * what renders before Clerk decides which way to send the user.
 */
export function Loader({ className, label = 'Loading…' }) {
	return (
		<div className={cn('flex min-h-screen items-center justify-center gap-3 text-muted-foreground', className)} role="status">
			<Loader2 className="h-5 w-5 animate-spin text-primary" aria-hidden />
			<span className="text-sm">{label}</span>
		</div>
	);
}
